export const LOCALES = ['en', 'de', 'fi'];
export const DEFAULT_LOCALE = 'en';
export const LOCALE_STORAGE_KEY = 'apex_ui_locale';

/** Path slug → Contentful locale code. Locales omitted here stay on src/content. */
export const CONTENTFUL_LOCALE_BY_SLUG = {
  en: 'en-US',
  de: 'de',
};

export const LOCALE_LABELS = {
  en: 'EN',
  de: 'DE',
  fi: 'FI',
};

export const LOCALE_NAMES = {
  en: 'English',
  de: 'Deutsch',
  fi: 'Suomi',
};

export function toContentfulLocale(slug) {
  return CONTENTFUL_LOCALE_BY_SLUG[slug] || null;
}
